export default class ScaleInput {
  constructor(name, imageDataManager) {
    this._elScale = document.querySelector(`.toolOptionGroup [name="${name}Scale"]`);
    this._elSize = document.querySelector(`.toolOptionGroup [name="${name}Size"]`);
    this._imageDataManager = imageDataManager;
  }
  get() {
    const {value, min, max} = this._elScale;
    return Math.max(min, Math.min(value, max));
  }
  update() {
    const elWidth = this._elSize.querySelector('.width');
    const elHeight = this._elSize.querySelector('.height');
    const scale = this.get();
    elWidth.innerText = this._imageDataManager.width * scale;
    elHeight.innerText = this._imageDataManager.height * scale;
  }
}
